import React from 'react'
import { ToastContainer } from 'react-toastify'
import UseServiceDuration from './Hooks/useServiceDuration';
import { useNavigate } from 'react-router-dom';
import { Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';
import Pagination from '../Pagination/pagination';
import Spinner from '../Spinner/spinner';

const ServiceDuration = () => {
    const {
        setPage,
        statusChange,
        setDeleteShow,
        deleteDuration,
        deleteShow,
        count,
        duration,
        PER_PAGE,
        page,
        spinner
    } = UseServiceDuration()
    const navigate = useNavigate()
    return (
        <section>
            <ToastContainer />
            <div className="m-t-3 cus-padd cusheight">
                {spinner ? <Spinner /> : null}
                <header>
                    <h2 className='page-tittle'>
                        Duration
                    </h2>
                    <hr />
                </header>
                <button className='btn btn-dark ms-1 float-end mb-2' onClick={() => navigate('add-duration')}>Add Duration</button>
                <table className="table  shadow mt-3">
                    <thead className="table-dark">
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">Durations(Minutes)</th>
                            <th scope="col">Status</th>
                            <th scope="col">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            duration?.map((item, index) =>
                                <tr key={index}>
                                    <td>{PER_PAGE * (page - 1) + index + 1}</td>
                                    <td>{item.duration}</td>
                                    <td> <div className="form-check form-switch" style={{ marginLeft: '44%' }}>
                                        <input className="form-check-input" role='switch' type="checkbox" checked={item.isActive} onChange={() => statusChange(item)} />
                                    </div></td>
                                    <td className='cursor' onClick={() => { setDeleteShow((pre) => ({ ...pre, open: true, data: item })) }}>

                                        <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">Delete</Tooltip>}>
                                            <i className="fa-solid fa-trash-can text-danger pt-1"></i>
                                        </OverlayTrigger>
                                    </td>
                                </tr>
                            )
                        }
                    </tbody>
                </table>
                <div className='w-100 d-flex justify-content-center'>
                    {count > 10 &&
                        <Pagination setpage={setPage} count={Math.ceil(count / PER_PAGE)} page={page} />
                    }
                </div>
            </div>
            {/* Duration Delete Start */}
            <Modal centered show={deleteShow?.open} size='sm' onHide={() => setDeleteShow({ open: false, data: '' })}>
                <div className="modal-content">
                    <div className="modal-body text-center">
                        <p>Are you sure !</p>
                        <p>You want to delete this duration</p>
                        <button type="button" className="btn nobtn" onClick={() => setDeleteShow({ open: false, data: '' })}>
                            No
                        </button>
                        <button type="button" className="btn yesbtn" onClick={() => deleteDuration()}>
                            Yes
                        </button>
                    </div>
                </div>
            </Modal>   
            {/* Duration Delete End */}
        </section>
    )
}

export default ServiceDuration
